exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hidden-checkbox{display:none}.checked-image{border:2px solid #00f}", ""]);

// exports
